var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V12.3636H3.09091V15.4545H6.18182V12.3636H12.3636V0H0ZM12.3636 12.3636V15.4545H15.4545V18.5455H9.27273V21.6364H0V34H12.3636V21.6364H21.6364V18.5455H18.5455V15.4545H24.7273V12.3636H27.8182V15.4545H30.9091V12.3636H34V0H21.6364V12.3636H12.3636ZM30.9091 15.4545V18.5455H34V15.4545H30.9091ZM30.9091 18.5455H27.8182V21.6364H30.9091V18.5455ZM30.9091 21.6364V24.7273H34V21.6364H30.9091ZM30.9091 24.7273H27.8182V21.6364H24.7273V24.7273H17V34H20.0909V27.8182H26.2727V30.9091H29.3636V27.8182H30.9091V24.7273ZM26.2727 30.9091H23.1818V34H26.2727V30.9091ZM27.8182 18.5455V15.4545H24.7273V18.5455H27.8182ZM9.27273 18.5455V15.4545H6.18182V18.5455H9.27273ZM3.09091 15.4545H0V18.5455H3.09091V15.4545ZM15.4545 0V6.18182H13.9091V9.27273H15.4545V10.8182H18.5455V6.18182H20.0909V3.09091H18.5455V0H15.4545ZM3.09091 3.09091H9.27273V9.27273H3.09091V3.09091ZM24.7273 3.09091H30.9091V9.27273H24.7273V3.09091ZM4.63636 4.63636V7.72727H7.72727V4.63636H4.63636ZM26.2727 4.63636V7.72727H29.3636V4.63636H26.2727ZM3.09091 24.7273H9.27273V30.9091H3.09091V24.7273ZM4.63636 26.2727V29.3636H7.72727V26.2727H4.63636ZM30.9091 30.9091V34H34V30.9091H30.9091Z",
    fill: "#FA9418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.94db0a5cb4030cd02a012c6adb6beae1.svg";
export { ForwardRef as ReactComponent };